// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1_2Jv","info":"UpdateTermsInfo_info__3ep4l"};